import 'core-js/stable';
import 'regenerator-runtime/runtime';


export const checkStorageMixin = {
    data: function () {
        return {            
            isEdge: /Edge/i.test(navigator.userAgent),
            isChrome: /Chrome/i.test(navigator.userAgent),
            isIE: /rv:11.0/i.test(navigator.userAgent),
            isStorageDisabled: false,
            pathToActivateStorage: null,
        };
    },
    created: function () {
        this.checkSessionAndLocalStorage();
    },
    methods: {        
        checkSessionAndLocalStorage: function () {
            try {
                if (!window.sessionStorage || !window.localStorage) {
                    this.detectBrowserType();
                    this.isStorageDisabled = true;
                } else {
                    this.isStorageDisabled = false;
                }
            } catch (exception) {
                this.detectBrowserType();
                this.isStorageDisabled = true;
            }
        },
        detectBrowserType: function () {
            if (this.isIE) {
                this.pathToActivateStorage = this.$t('localSessionStorage.pathToStorageForIE');
            } else if (this.isEdge) {
                this.pathToActivateStorage = this.$t('localSessionStorage.pathToStorageForEdge');
            } else if (this.isChrome) {
                this.pathToActivateStorage = this.$t('localSessionStorage.pathToStorageForChrome');
            }
        },
    },
};


// WEBPACK FOOTER //
// ./common/mixins/checkStorageMixin.ts